import { Client } from '../api-client';

const getActiveSaarthiBatches = () => 'v3/saarthi/my-active-saarthi';
const getSaarthiDetails = () => 'v3/saarthi/details';
const getMapping = (saarthiId: string, subjectId: string) =>
  `v3/saarthi/${saarthiId}/subject/${subjectId}/get-mapping`;
const insertChat = (conversationId: string) => 'v1' + `/conversation/${conversationId}/chat`;
const getChatUrl = (conversationId: string) => `v1/conversation/${conversationId}/chat`;

export const activeSaarthiFetcher = ({ queryKey }: any) => {
  const { saarthi_id, premium } = queryKey[1];
  const params: any = {
    // class: className,
    // exam,
    saarthi_id,
    ...(premium !== undefined && { premium }),
  };
  return Client.get(getActiveSaarthiBatches(), { params });
};

export const saarthiDetailsFetcher = ({ queryKey }: any) => {
  const { saarthiId } = queryKey[1];
  const params = {
    saarthi_id: saarthiId,
  };

  return Client.get(getSaarthiDetails(), { params });
};

export const mappingFetcher = ({ queryKey }: any) => {
  const { saarthiId, subjectId } = queryKey[1];

  return Client.get(getMapping(saarthiId, subjectId));
};

export const insertChatFetcher = (data: any): any => {
  const { conversationId, ...payload } = data;
  return Client.post(insertChat(conversationId), { ...payload });
};
// export const getChatsFetcher = ({ queryKey, pageParam = 1 }: any) => {
//   const { conversationId } = queryKey[1]
//   const params: {
//     page: pageParam,

//   }

//   return Client.get(getChatUrl(conversationId), {
//     params,
//   })
// }
export const getChatsFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { conversationId, limit } = queryKey[1];
  const params: any = {
    page: pageParam,
    limit: limit,
  };
  return Client.get(getChatUrl(conversationId), {
    params,
  });
};
